var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./Footer.jinja');
require('./Footer.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Footer/Footer.js
// module id = 139
// module chunks = 0